<section class="simulation grid-container login-page--lg">
    <div>
        <div class="page-header">
            <p class="simulation__panelTitle page-title">
                {{ 'reset.popup.title' | i18n }}
            </p>
            <div class="hide-mobile login-page__caisse">
                <div *ngIf="selectedCaisse" class="login-page__caisseTitle">
                    {{ selectedCaisse.name }}
                </div>
            </div>
        </div>
        <div class="login-page__subtitle">{{ 'reset.subtitle' | i18n }}</div>
        <div class="login-page__content">
            <form method="POST" name="resetPasswordForm" novalidate="" (ngSubmit)="submitResetPasswordForm()" [formGroup]="resetPasswordForm" class="grid-10 grid-mobile-4">
                <div class="grid-12 login-page__input">
                    <label class="grid-6 grid-mobile-4" for="otp"> {{ 'reset.form.otp.label' | i18n }} : </label>
                    <input class="grid-6 grid-mobile-4 textfield" id="otp" name="otp" formControlName="otp" maxlength="20" required="" />
                </div>
                <div class="grid-6 push-6 grid-mobile-4 push-mobile-0">
                    <span class="login-page__inputdesc">
                        {{ 'reset.form.sendsms.text' | i18n }}
                    </span>
                    <span class="login-box__link" id="sendSmsBtn" (click)="sendResetPasswordSms(true)">{{ 'reset.form.sendsms.clickme' | i18n }} </span>
                    <span *ngIf="sendSMSSuccess" class="form-message--tiny form-message--success">
                        {{ 'reset.form.sendsms.success' | i18n }}
                    </span>
                </div>

                <app-password-creation [form]="resetPasswordForm" [label]="'reset.form.password.label' | i18n" [labelRepeat]="'reset.form.repeatPassword.label' | i18n"> </app-password-creation>

                <div class="grid-12 login-page__input simulation__group login-page__button">
                    <button
                        type="submit"
                        id="submitBtn"
                        class="grid-6 push-6 grid-mobile-4 push-mobile-0 button button--primary"
                        data-tag-commander=""
                        [appTagCommander]="'tagCo.reset.form.submit.button'"
                        data-api-call-button=""
                        [disabled]="!resetPasswordForm.valid || newPassword.value !== repeatPassword.value"
                    >
                        {{ 'reset.form.submitbutton' | i18n }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>

<app-simple-message-modal [modalTitle]="'reset.popup.title'" [content]="'reset.popup.body'" [closeButton]="'reset.popup.yes'" [visibility]="passwordResetSuccess" (buttonClicked)="goBackToLogin()" [centered]="false">
</app-simple-message-modal>
